import { BookingServiceClient, UserServiceClient } from 'fitbeat.api-clients';
import { BookingsManager, UserWorkoutSession } from 'fitbeat.gym-core';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import {getApiConfig } from '../config';
import { Logger } from '../utils/Logger';

interface IInfluencerData {
  influencerBookings: UserWorkoutSession[][];
  influencerName: string;
  isLoadingBookings: boolean;
  isLoadingAvatar: boolean;
  avatar: string | null;
  landingPage: string | undefined;
  personalisedHeader: string | undefined;
}

export const useInfluencerData = (
  influencerId: string,
  screenFocussed: boolean,
): IInfluencerData => {
  const [isLoadingBookings, setIsLoadingBookings] = useState(true);
  const [isLoadingAvatar, setIsLoadingAvatar] = useState(true);
  const [influencerBookings, setInfluencerBookings] = useState<
    UserWorkoutSession[][]
  >([]);
  const [influencerName, setInfluencerName] = useState<string>('');
  const [landingPage, setLandingPage] = useState<string | undefined>(undefined);
  const [personalisedHeader, setPersonalisedHeader] = useState<string | undefined>(undefined);
  const [avatar, setAvatar] = useState(null);
  const bookingServiceClient = new BookingServiceClient(getApiConfig(), fetch);
  const userServiceClient = new UserServiceClient(
    getApiConfig(),
    fetch,
    Logger.debug,
    undefined,
  );
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result =
          await bookingServiceClient.getInfluencerAvailableBookings(
            influencerId,
          );
        const bookingsGroupedByDay = BookingsManager.groupBookingsByDay(
          result.influencerBookings,
          moment.tz.guess(),
        );
        setInfluencerBookings(bookingsGroupedByDay);
        setInfluencerName(result.firstname);
        setLandingPage(result.landingPage);
        setPersonalisedHeader(result.personalisedHeader);
        setIsLoadingBookings(false);
      } catch (e) {
        setIsLoadingBookings(false);
      }
    };
    if (screenFocussed) {
      fetchData().catch((e) => Logger.notify(e));
    }
  }, [screenFocussed]);

  useEffect(() => {
    const getAvatar = async () => {
      try {
        const avatarImage = await userServiceClient.getInfluencerAvatar(
          influencerId,
        );
        if (avatarImage) {
          setAvatar(avatarImage.base64Avatar);
        }
        setIsLoadingAvatar(false);
      } catch {
        setIsLoadingAvatar(false);
      }
    };
    getAvatar().catch((e) => Logger.notify(e));
  }, []);
  return {
    influencerBookings,
    influencerName,
    isLoadingBookings,
    avatar,
    isLoadingAvatar,
    landingPage,
    personalisedHeader,
  };
};
